import EnvironmentBanner from 'screens/Panel/components/EnvironmentBanner/EnvironmentBanner';
import { connect } from 'react-redux';
import { RootState } from 'store/configureStore';
import { AUTH_STATUSES } from 'auth/types';
import { ENVIRONMENT } from 'utils/environment';

const EnvironmentBannerConnection = connect(
  (state: RootState) => ({
    isLoggedIn: state.auth.status === AUTH_STATUSES.AUTHENTICATED,
    environmentsAllowedToRenderBanner: [ENVIRONMENT.DEMO, ENVIRONMENT.STAGING],
  }),
  {},
)(EnvironmentBanner);

export default EnvironmentBannerConnection;
